import type { ReactNode } from 'react';
import { PageContainer } from '../PageContainer/PageContainer';
import { TemplateSection } from './Section';

export type ExploreHubTemplateProps = {
  header: ReactNode;
  /** The RegionMap. */
  map?: ReactNode;
  /** A sortable Table of regions (open jobs, typical pay, TrendChip); every row links to a search. */
  table?: ReactNode;
  /** Role or category tiles, each linking into filtered search results. */
  tiles?: { title: ReactNode; content: ReactNode };
  className?: string;
};

/** Explore hubs: locations, roles, salary, remote, career paths, collective agreements. Every figure from the snapshot with its basis. */
export function ExploreHubTemplate({ header, map, table, tiles, className }: ExploreHubTemplateProps) {
  return (
    <PageContainer className={className}>
      <div className="flex flex-col gap-jc-section py-jc-section">
        {header}
        {map || table ? (
          <div className="grid items-start gap-jc-block lg:grid-cols-5">
            {map ? <div className="lg:col-span-2">{map}</div> : null}
            {table ? <div className={map ? 'min-w-0 lg:col-span-3' : 'min-w-0 lg:col-span-5'}>{table}</div> : null}
          </div>
        ) : null}
        {tiles ? (
          <TemplateSection id="tiles" title={tiles.title}>
            <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-4">{tiles.content}</div>
          </TemplateSection>
        ) : null}
      </div>
    </PageContainer>
  );
}
